var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "./base";
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        var _this = _super.call(this) || this;
        var mainDiv = document.createElement('div');
        mainDiv.className = 'lds-ripple';
        var firstInternalDiv = document.createElement('div');
        mainDiv.appendChild(firstInternalDiv);
        var secondInternalDiv = document.createElement('div');
        mainDiv.appendChild(secondInternalDiv);
        mainDiv.insertAdjacentHTML('beforeend', "\n        <style type=\"text/css\">\n        .lds-ripple {\n        color: #1c4c5b\n        }\n        .lds-ripple,\n        .lds-ripple div {\n        box-sizing: border-box;\n        }\n        .lds-ripple {\n        display: inline-block;\n        position: relative;\n        width: 75px;\n        height: 75px;\n        }\n        .lds-ripple div {\n        position: absolute;\n        border: 4px solid currentColor;\n        opacity: 1;\n        border-radius: 50%;\n        animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n        }\n        .lds-ripple div:nth-child(2) {\n        animation-delay: -0.5s;\n        }\n        @keyframes lds-ripple {\n        0% {\n            top: 36px;\n            left: 36px;\n            width: 8px;\n            height: 8px;\n            opacity: 0;\n        }\n        4.9% {\n            top: 36px;\n            left: 36px;\n            width: 8px;\n            height: 8px;\n            opacity: 0;\n        }\n        5% {\n            top: 36px;\n            left: 36px;\n            width: 8px;\n            height: 8px;\n            opacity: 1;\n        }\n        100% {\n            top: 0;\n            left: 0;\n            width: 80px;\n            height: 80px;\n            opacity: 0;\n        }\n        }\n        </style>\n        ");
        _this.self = mainDiv;
        return _this;
    }
    return Loader;
}(Base));
export { Loader };
